import { render } from "./IconTent.vue?vue&type=template&id=b971b22a"
import script from "./IconTent.vue?vue&type=script&lang=js"
export * from "./IconTent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__